import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10 system-settings" }
const _hoisted_2 = { class: "card-body p-9" }
const _hoisted_3 = { class: "pb-10" }
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = { class: "pb-10 pb-lg-15 pt-10 text-center" }
const _hoisted_6 = { class: "fw-bolder text-center" }
const _hoisted_7 = { class: "text-gray-400 fw-bold fs-6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "col-md-8" }, null, -1)
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "d-flex flex-column mb-4 fv-row" }
const _hoisted_12 = { class: "d-flex align-items-center fs-6 fw-bold mb-1" }
const _hoisted_13 = { class: "fv-row mb-8" }
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  style: {"min-height":"122px"}
}
const _hoisted_16 = {
  key: 1,
  class: "row"
}
const _hoisted_17 = { class: "col-lg-4" }
const _hoisted_18 = { class: "col-lg-4" }
const _hoisted_19 = { class: "col-lg-4" }
const _hoisted_20 = { class: "col-lg-4 my-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_EconomicLoader = _resolveComponent("EconomicLoader")!
  const _component_CustomerGroup = _resolveComponent("CustomerGroup")!
  const _component_IndividualCustomer = _resolveComponent("IndividualCustomer")!
  const _component_IndividualProduct = _resolveComponent("IndividualProduct")!
  const _component_ArchivedOrder = _resolveComponent("ArchivedOrder")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t('message.ECONOMIC')), 1),
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('message.HANDLE_ALL_ECONOMIC_DATA_ACCORDING_TO_COUNTRY')), 1)
          ]),
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("label", _hoisted_12, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('message.COUNTRY')), 1)
                ]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.country_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.country_id = $event)),
                  placeholder: "Select"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countries, (group) => {
                      return (_openBlock(), _createBlock(_component_el_option_group, {
                        key: group.label,
                        label: group.label
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.options, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            (_ctx.loader)
              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                  (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (i) => {
                    return _createVNode("div", {
                      class: "col-lg-4 my-4",
                      key: i
                    }, [
                      _createVNode("label", _hoisted_15, [
                        _createVNode(_component_EconomicLoader)
                      ])
                    ])
                  }), 64))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode(_component_CustomerGroup, { country_id: _ctx.country_id }, null, 8, ["country_id"])
                  ]),
                  _createVNode("div", _hoisted_18, [
                    _createVNode(_component_IndividualCustomer, { country_id: _ctx.country_id }, null, 8, ["country_id"])
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _createVNode(_component_IndividualProduct, { country_id: _ctx.country_id }, null, 8, ["country_id"])
                  ]),
                  _createVNode("div", _hoisted_20, [
                    _createVNode(_component_ArchivedOrder)
                  ])
                ]))
          ])
        ])
      ])
    ])
  ]))
}